(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('Periodos', Periodos);

    Periodos.$inject = ['$resource'];

    function Periodos ($resource) {
        var resourceUrl =  'apo/periodo/:anio,:dep,:ic';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
